export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'DD MMM, YYYY HH:MM';
export const DATE_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm';
export const DATE_MONTH_YEAR_VIEW_FORMAT = 'DD MMM, YYYY';
export const DATE_MONTH_YEAR_TIME_FORMAT = 'DD MMM, YYYY hh:mm A';
export const DATE_MONTH_VIEW_FORMAT = 'ddd, DD MMM';
export const DAY_DATE_MONTH_YEAR_VIEW_FORMAT = 'ddd, DD MMM, YYYY';
export const MONTH_YEAR_FORMAT = 'MMM, YY';
export const ONLY_DATE_FORMAT = 'DD';
export const ONLY_TIME_FORMAT = 'hh:mm a';
export const MOMENT_DATE_MONTH_YEAR_VIEW_FORMAT = 'DD MMM, YYYY';
export const TIME_DAY_FORMAT = 'hh:mm a, eee';
export const MONTH_TIME_FORMAT = 'MMM | HH:mm';
export const MONTH_FORMAT = 'MMM';
export const ONLY_DATE_MONTH_FORMAT = 'DD MMM';
export const DATE_MONTH_YEAR_FORMAT = 'DD/MM/YYYY';
export const DATE_MONTH_DAY_FORMAT = 'DD MMM, ddd';
export const YEAR_MONTH_DATE_WITHOUT_SEPERATION = 'YYYYMMDD';
export const TODAY_DATE = 'TODAY_DATE';
export const API_REQUEST_DATE_FORMAT_SLASH = 'YYYY/MM/DD';
export const DATE_MONTH_HOURS_MINUTE_FORMAT = 'DD-MMM HH:mm';
export const DATE_MONTH_YEAR_WITH_HYPHEN = 'DD-MMM-YYYY';
export const DATE_FORMAT_WITHOUT_SEPARATION = 'DDMMYYYY';
export const SESSION_TIME = 60 * 60 * 1000; // session time-out to be 1 hour
export const APP_LOGGEDIN_AGENTID = 'APP_LOGGEDIN_AGENTID';

export const NAVIGATION_ROUTES = {
  AGENT_REGISTRATION: '/agent-registration',
  PROFILE: {
    PROFILE_ROUTE: '/profile',
    EDIT_PROFILE: '/profile/edit-profile',
    LEDGER: '/profile/ledger',
    SAVED_TRAVELLERS_ROUTE: '/profile/saved-travellers',
    STAFF_ROUTE: '/staff',
  },
  TRIP_PROTECTION: '/trip-protection',
  INSUARNCE_VOUCHER: '/trip-protection/voucher/:transactionId',
  INSUARNCE_INVOICE: '/trip-protection/invoice/:transactionId',
  INSURANCE_CANCEL: '/trip-protection/cancel/:transactionId',
  MY_BOOKINGS_ROUTE: '/my-bookings',
  MANAGE_BOOKING: '/my-bookings/manage',
  CANCEL_BOOING: '/my-bookings/manage/:transactionId/cancel',
  PASSENGER_CALENDER: '/passenger-calender',
  CHANGE_BOOKING: {
    RESCHEDULE_RESULTS: '/change-booking/:transactionId/results',
    RESCHEDULE_ROUNDTRIP_RESULTS:
      '/change-booking/:transactionId/roundtrip-results',
    RESCHEDULE_ROUNDTRIP_INTL_RESULTS:
      '/change-booking/:transactionId/roundtrip-intl-results',
    RESCHEDULE_BOOKING: '/change-booking/:transactionId/booking',
  },
  MANAGE_ALL_BOOKINGS: '/manage-booking',
  LOGIN: '/login',
  AGENT_MARKUP: '/agent-markup',
  CREDIT_DEBIT_NOTE: '/credit-debit-receipt/:transactionId',
  TOP_UP_RECEIPT: '/top-up-receipt/:transactionId',
  LANDING: '/search',
  FLIGHT: {
    LANDING: '/flight',
    ONE_WAY_FLIGHT_RESULTS_ROUTE: '/flight/owresults',
    ROUND_TRIP_FLIGHT_RESULTS_ROUTE: '/flight/rtresults',
    INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE: '/flight/rtintlresults',
    FLIGHT_BOOK_ROUTE: '/flight/book',
    FLIGHT_TICKET_PAGE: '/flight/ticket/:transactionId',
    FLIGHT_INVOICE_PAGE: '/flight/invoice/:transactionId',
    FLIGHT_CUSTOMER_INVOICE_PAGE: '/flight/customer-invoice/:transactionId',
    FLIGHT_ADD_SSR: '/flight/add-ssr/:transactionId',
    FLIGHT_PASSENGER_CALENDAR: '/flight/passenger-calendar',
    FLIGHT_ORDER_DETAILS: '/flight/order-details/:transactionId',
    FLIGHT_GROUP_BOOKING: '/flight/agent-support',
    FLIGHT_HOLD_QUEUES: '/flight/hold-queues',
    FLIGHT_RESHEDULE_PAGE: '/flight/reshedule/:transactionId',
    FLIGHT_ONLINE_RESHEDULE_PAGE: '/flight/reshedule-online/:transactionId',
    FLIGHT_CANCELLATION_PAGE: '/flight/cancellation/:transactionId',
    FLIGHT_OFFLINE_SSR: '/flight/offline-ssr-booking',
    FLIGHT_REFUND_RECEIPT: '/flight/refund-receipt/:transactionId',
    DOM_MULTICITY_RESULTS_ROUTE: '/flight/dom-multicity',
    DOM_MULTICITY_BOOKING_ROUTE: '/flight/book-multi-city',
    INTL_MULTICITY_RESULTS_ROUTE: '/flight/intl-multicity',
  },
  HOTEL: {
    LANDING: '/hotel',
    HOTEL_SEARCH: '/hotel/search-results',
    HOTEL_DETAILS: '/hotel/details',
    REVIEW_BOOKING: '/hotel/review-booking',
    MANAGE_BOOKING: '/hotel/bookings',
    BOOKING_DETAILS: '/hotel/booking-details/:transactionId',
    PRINT_TICKETS: '/hotel/print-ticket/:transactionId',
    VOUCHER: '/hotel/voucher/:transactionId',
    HOTEL_BOOKING_CALENDAR: '/hotel/booking-calendar',
    HOTEL_CANCELLATION: '/hotel/cancel/:transactionId',
    HOTEL_INVOICE: '/hotel/invoice/:transactionId',
    HOTEL_CREDIT_NOTE: '/hotel/creditnote/:transactionId',
  },
  CABS: {
    LANDING: '/cabs',
    CABS_SEARCH: '/cabs/search-results',
    REVIEW_BOOKING: '/cabs/review-booking',
    MANAGE_BOOKING: '/cabs/bookings',
    BOOKING_DETAILS: '/cabs/booking-details/:transactionId',
    PRINT_TICKETS: '/cabs/print-ticket/:transactionId',
    CABS_INVOICE: '/cabs/invoice/:transactionId',
    CABS_CREDIT_NOTE: '/cabs/creditnote/:transactionId',
    CABS_VOUCHER: '/cabs/voucher/:transactionId',
  },
  BUS: {
    LANDING: '/bus/search',
    BUS_SEARCH: '/bus/search-results',
    REVIEW_BOOKING: '/bus/review-booking',
    BOOKING_DETAILS: '/bus/:transactionId/booking-details',
    BOOKING_CANCEL: '/bus/:transactionId/booking-cancel',
    BOOKING_CANCEL_DETAILS: '/bus/:transactionId/cancellation-details',
    MANAGE_BOOKING: '/bus/bookings',
    PRINT_TICKETS: '/bus/print-ticket/:transactionId',
    BUS_INVOICE: '/bus/invoice/:transactionId',
    BUS_CREDIT_NOTE: '/bus/credit-note/:transactionId',
  },
  TRAIN: {
    LANDING: '/train/search',
    TRAIN_SEARCH: '/train/search-results',
    TRAIN_BOOK: '/train/book',
    TRAIN_TICKET: '/train/ticket',
    TRAIN_DETAILS: '/train/:transactionId/details',
    TRAIN_RAISE_TDR: '/train/:transactionId/raise-tdr',
    TRAIN_CANCEL: '/train/:transactionId/cancel',
    TRAIN_CREDIT_NOTE: '/train/:transactionId/credit-note',
    TRAIN_PNR_STATUS: '/train/pnr-status',
    TRAIN_PASSENGER_CALENDAR: '/train/passenger-calendar',
    TRAIN_CERTIFICATE: '/train/certificate',
    TRAIN_ADVANCE_SEARCH: '/train/advance-search',
    TRAIN_PAX_INVOICE: '/train/customer-invoice/:transactionId',
    TRAIN_AGENT_INVOICE: '/train/agent-invoice/:transactionId',
    TRAIN_CONFIRMATION: '/train/confirm/:transactionId',
    TRAIN_CANCELLATION_RECEIPT: '/train/cancellation-receipt/:transactionId',
  },
};
export const STATUS = {
  RESCHEDULED: 'rescheduled',
  CANCELLED: 'cancelled',
};
export const BUS_PAX = {
  title: '',
  firstname: '',
  lastname: '',
  gender: '',
  age: '',
  seatnumber: '',
  seatprice: 0,
  isprimary: true,
};
export const CABS_PAX = {
  title: '',
  firstname: '',
  lastname: '',
  dob: '',
  age: 27,
  address: '',
  gender: '',
  paxtype: 'Adult',
  email: '',
  countryPhoneCode: '+91',
  phone: '',
  documentType: '',
  documentNumber: '',
  documentIssueDate: '',
  documentExpiryDate: '',
  nationality: '',
  isLead: false,
  roomNumber: 0,
  panCardNumber: '-',
  city: '',
  country: '',
  mobile: '',
  pincode: '560064',
  state: '',
};
export const checkValidMobileNumber = (mobile) => {
  return mobile !== '' && /^[5-9]\d{9}$/gi.test(mobile) === false;
};
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const checkValidEmailAddress = (email) => {
  if (email.trim() === '') {
    return true;
  }
  const emails = email.split(';');
  let error = false;
  emails.forEach((em) => {
    if (!EMAIL_REGEX.test(em)) {
      error = true;
    }
  });
  return error;
};
export const pan_regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const checkValidPanNumber = (pan) => {
  try {
    if (!pan || pan.trim() === '') {
      return true;
    }

    const panNumbers = pan.split(';');
    let error = false;

    panNumbers.forEach((em) => {
      if (!pan_regex.test(em)) {
        error = true;
      }
    });

    return error;
  } catch (err) {
    //
    return true; // Treat as invalid if any exception occurs
  }
};

export const checkValidName = (name) => {
  return name?.trim() !== '' && /^[a-zA-Z ]*$/gi.test(name) === false;
};
export const checkValidPassport = (passport) => {
  if (!passport) return false;
  return /^[A-Z][0-9]{7}$/.test(passport.trim());
};
export const checkValidCompanyName = (name) => {
  return name?.trim() !== '' && /^[a-zA-Z0-9 ]*$/gi.test(name) === false;
};
export const GENDER_OPTIONS_DICT = {
  male: 'Male',
  female: 'Female',
  others: 'Others',
};

export const STATUS_OPTIONS_DICT = {
  confirmed: 'Confirmed',
  cancelled: 'Cancelled',
  rolledback: 'Rolled Back',
};

export const PAX_TYPE_DICT = {
  adult: 'Adult',
  child: 'Child',
  infant: 'Infant',
};

export const PREF_CLASS_OPTIONS = {
  Y: 'Economy',
  W: 'Premium Economy',
  C: 'Business',
  F: 'First Class',
};

export const SESSION_KEY_EMPTY = 'refreshMyBookings';
export const FARE_SOURCES = [83, 24, 91, 51, 33];

export const INDIGO_FARERULES_LINK =
  'https://www.goindigo.in/information/fees-and-charges.html?linkNav=fees-and-charges_header';
